import { render, staticRenderFns } from "./LoginSyscor.vue?vue&type=template&id=aec75ad4&"
import script from "./LoginSyscor.vue?vue&type=script&lang=js&"
export * from "./LoginSyscor.vue?vue&type=script&lang=js&"
import style0 from "./LoginSyscor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports